import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function OurMotto() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">Our Motto</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> Our Motto</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Our Motto</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 text-center my-5">
                            <p><b>Our Motto: Love One Another 💛</b></p>
                            <p>At St. Mary’s Nursery School, Bokaro, we believe that the foundation of learning is love. Our motto, “Love One Another,” is not just words it is the heartbeat of everything we do.</p>
                        </div>
                        
                        <div className="col-12">
                            <p>🌈 Caring Classrooms: Every child is encouraged to be kind, gentle, and understanding towards friends and teachers alike. Sharing, helping, and respecting each other is woven into every activity.</p>
                            <p>🎨 Play-Way Learning with Love: Through joyful play, creative arts, and collaborative games, children learn to appreciate differences, celebrate successes together, and offer support when someone needs it.</p>
                            <p>🌞 Responsible Little Citizens: By practicing empathy and compassion from the very beginning, our little learners grow into thoughtful, caring, and responsible individuals who make the world around them a better place.</p>
                            <p>💫 Every Smile Matters: At SMNS, a smile is a language everyone understands. Encouraging children to love, care, and share ensures a happy, safe, and nurturing environment for every little star in our school.</p>
                            <p className="text-center"><b>Because when we truly love one another, learning becomes fun, friendships grow strong, and the school feels like a second home.<br />
                                &<br />
                                “SMNS – A Second Home Filled with Love and Joy”</b></p>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default OurMotto